export default "__VITE_ASSET__DQ6Xoxg9__"